import React, { useContext } from "react";

const RootContext = React.createContext(null);

function useRootStore() {
    return useContext(RootContext);
}

export { RootContext, useRootStore };
